module.exports = __webpack_public_path__ + "img/1.9399e370.png";